import cn from 'classnames';
import React, { PropsWithChildren } from 'react';

const defaultProps = {
  compact: false as boolean,
  bordered: true as boolean,
  orientation: 'horizontal' as 'horizontal' | 'vertical'
};

type DefaultProps = Readonly<typeof defaultProps>;

type Props = PropsWithChildren<Partial<DefaultProps>>;

export const Table = React.forwardRef<HTMLTableElement, Props>((props, ref) => {
  const { children, bordered, compact, orientation } = props;
  const classNames = cn('table', {
    'table-vertical': orientation === 'vertical',
    'table-noborder': !bordered,
    'table-compact': compact
  });
  return (
    <table ref={ref} className={classNames}>
      {children}
    </table>
  );
});

Table.defaultProps = defaultProps;

export const TableHeader = React.forwardRef<
  HTMLTableSectionElement,
  PropsWithChildren<{}>
>(({ children }, ref) => <thead ref={ref}>{children}</thead>);

export const TableBody: React.FunctionComponent<React.PropsWithChildren<Props>> = (props) =>  <tbody>{props.children}</tbody>;

type AlignProps = PropsWithChildren<{
  align?: 'left';
}>;

export const TableHeading = React.forwardRef<
  HTMLTableHeaderCellElement,
  AlignProps
>(({ children, align }, ref) => (
  <th ref={ref} className={align}>
    {children}
  </th>
));

export const TableRow = React.forwardRef<
  HTMLTableRowElement,
  PropsWithChildren<{}>
>(({ children }, ref) => <tr ref={ref}>{children}</tr>);

export type CellProps = PropsWithChildren<
  {
    colSpan?: number;
  } & AlignProps
>;

export const TableCell = React.forwardRef<HTMLTableDataCellElement, CellProps>(
  (props, ref) => {
    const { align, colSpan, children } = props;
    return (
      <td ref={ref} className={align} colSpan={colSpan}>
        {children}
      </td>
    );
  }
);
